import { Labels } from '../../shared-components/global/labels.js';

Labels.set('validation', 'input', 'Please enter a valid value.');
Labels.set('validation', 'date', 'Please enter a valid value.');
Labels.set('validation', 'time', 'Please enter a time.');
Labels.set('validation', 'range', 'Invalid input.');
Labels.set('validation', 'month', 'Please enter a valid month.');
Labels.set('validation', 'datetime-local', 'Please enter a datetime.');
Labels.set('validation', 'datetime-local', 'Ievadiet datumu.');
Labels.set('validation', 'custom', 'Validation custom error.');
Labels.set('validation', 'pattern', 'Please match the format.');
Labels.set(
    'validation',
    'rangeOverflow',
    'Value must be less than or equal %s.'
);
Labels.set(
    'validation',
    'rangeUnderflow',
    'Value must be greater than or equal %s.'
);
Labels.set(
    'validation',
    'step',
    'Step should be %s, nearest values are %s and %s.'
);
Labels.set(
    'validation',
    'long',
    'Value is too long, maximum length is %s symbols.'
);
Labels.set(
    'validation',
    'short',
    'Value is too short, minimum length is %s symbols.'
);
Labels.set('validation', 'type', 'Please enter a valid value.');
Labels.set('validation', 'email', 'Please enter an email address.');
Labels.set('validation', 'url', 'Please enter a URL.');
Labels.set('validation', 'value', 'Please fill out this field.');

// User defined rule validations
Labels.set('validation', 'matches', "Fields values don't match.");
Labels.set('validation', 'checkboxes', 'Please select at least %s option(s).');
Labels.set('validation', 'remote', 'Wrong response from server');
Labels.set('validation', 'maxfilesize', 'File size limit exceeded %s Kb.');
Labels.set(
    'validation',
    'requiredMultiple',
    'Please fill at least %s field(s).'
);
